import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/design-system/card';
import type { Product } from '@app/shared/types';

interface ProductCardProps {
  product: Product;
}

export const ProductCard = ({ product }: ProductCardProps) => {
  return (
    <Card className="group overflow-hidden transition-all duration-300 hover:shadow-lg hover:-translate-y-1">
      <div className="aspect-square overflow-hidden bg-muted">
        {product.imageUrl ? (
          <img
            src={product.imageUrl}
            alt={product.name}
            className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-110"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-muted to-muted-foreground/10">
            <span className="text-4xl text-muted-foreground">📦</span>
          </div>
        )}
      </div>
      <CardHeader className="space-y-1 pb-3">
        <CardTitle className="line-clamp-1 text-lg">{product.name}</CardTitle>
        {product.shortDescription && (
          <CardDescription className="line-clamp-2 text-sm">
            {product.shortDescription}
          </CardDescription>
        )}
      </CardHeader>
      <CardContent>
        <p className="text-2xl font-bold text-primary">
          ${parseFloat(product.price.toString()).toFixed(2)}
        </p>
      </CardContent>
    </Card>
  );
};
